import { TableHeadersType } from '../tableHeadersType';

export const ACTIVITY_CODE_HEADERS: TableHeadersType[] = [
  {
    "label": "ACTIVITY CODE",
    "value": "activity_code",
  
  },
  {
    "label": "DESCRIPTION",
    "value": "description",
  },
  {
    "label": "ACTIVITY CODE TYPE",
    "value": "activity_code_type",
  },
  {
    "label": "ADDED/MODIFIED BY",
    "value": "updated_by",
  },
   {
    "label": "ACTION",
    "value": "edit",
  },
];

